import { assetApi as api } from './assetApi';
export const addTagTypes = ['Assets'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      getAssets: build.query<GetAssetsApiResponse, GetAssetsApiArg>({
        query: queryArg => ({
          url: `/assets`,
          params: {
            search: queryArg.search,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sortby: queryArg.sortby,
            orderby: queryArg.orderby,
            userId: queryArg.userId,
            subscriberId: queryArg.subscriberId,
            type: queryArg['type']
          }
        }),
        providesTags: ['Assets']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type GetAssetsApiResponse = /** status 200 Assets found. */ {
  ok?: boolean;
  data?: Assets;
  message?: string;
};
export type GetAssetsApiArg = {
  /** Search text */
  search?: string;
  /** offset for pagination */
  offset?: number;
  /** number of rows to fetch */
  limit?: number;
  /** sort */
  sortby?: string;
  /** order */
  orderby?: string;
  /** userId */
  userId?: string;
  /** subscriberId */
  subscriberId?: string;
  /** type */
  type?: string;
};
export type Assets = {
  count: number;
  rows: {
    id?: string;
    status?: string;
    oldUrl?: string;
    newUrl?: string;
    type?: string;
    subscriberId?: string;
    userId?: string;
    metadata?: {
      size?: string;
      filters?: string;
      location?: string;
    };
    url?: string;
    thumbNailUrl?: string;
    createdAt?: string;
    updatedAt?: string;
    fileName?: any;
    contentType?: any;
    size?: any;
    createdBy?: any;
  }[];
};
export const { useGetAssetsQuery } = injectedRtkApi;
